import React from 'react';
import { Tag } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { isForceProductionStyle } from '@/constants/environment';

interface DevFilePathBadgeProps {
  filePath: string;
  style?: React.CSSProperties;
}

/**
 * 開発環境でのみ表示されるファイルパス表示バッジ
 * client/src/ 以下の相対パスを表示
 * 本番スタイル強制時は非表示
 */
export function DevFilePathBadge({ filePath, style }: DevFilePathBadgeProps): JSX.Element | null {
  // 本番環境または本番スタイル強制時は非表示
  if (import.meta.env.PROD || isForceProductionStyle()) {
    return null;
  }

  // client/src/ 以下のパスに変換
  const relativePath = filePath.replace(/^.*?client\/src\//, 'client/src/');

  return (
    <Tag
      icon={<FileTextOutlined />}
      color="purple"
      style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        zIndex: 9999,
        fontSize: 11,
        fontFamily: 'monospace',
        maxWidth: '400px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        ...style
      }}
      title={relativePath}
      onClick={() => {
        // クリップボードにコピー
        void navigator.clipboard.writeText(relativePath);
      }}
    >
      {relativePath}
    </Tag>
  );
}
